import React from 'react';
import { Redirect } from 'react-router-dom';
import { HomeLayout } from '../layout';
import { ModernLayout } from '../layouts/modern';
import Home from '../pages/home-page';
//import LogReport from '../components/Comingsoon';
//import EquipmentCheckComingsoon from '../components/EquipmentCheckComingsoon';
import Admin from '../pages/admin/asset-management';
//import UserManagement from '../pages/userManagement/UserManagement'
import AdminPage from '../pages/admin/index';
import WebpageMsg from '../components/WebpageMsg';
import Technical from '../pages/technical/Technical';
import HeatProfile from '../components/HeatProfile';
import HeatProfilePage from '../pages/technical/HeatProfilePage';
import AnalysisPage from '../pages/analysis/index';
//import TechnicalPage from '../components/CRCE Technical/TechnicalPage';
import TechnicalReportPage from '../components/CRCE Technical/TechnicalReportPage';
import DcalPage from '../components/DCAL/DcalPage';
import DCALGeneratorPage from '../pages/technical/DCALGeneratorPage';
import TestRepositoryPage from '../pages/technical/TestRepositoryPage';
import CalibrationPage from '../pages/calibration/CalibrationPage';
import AdminModernPage from '../pages/admin/AdminModernPage';
import TechnicalPageAgGrid from '../components/CRCE Technical/TechnicalPageAgGrid';
import TechnicalPDFViewer from '../components/CRCE Technical/TechnicalPDFViewer';
import DocControl from '../pages/technical/DocControl';
import DocControlMangement from '../components/Calibration/DocControlMangement';
//import Calibration from '../components/Calibration/Calibration';
//import CalibrationPageAgGrid from '../components/Calibration/CalibrationPageAgGrid';
import CalibrationMainPage from '../components/Calibration/CalibrationMainPage';
import AssistancePage from '../components/Assistance/AssistancePage';
import HeatProfilePDFViewer from '../components/Heatprofile/HeatProfilePDFViewer';
import ProjectHeatProfilePDFViewer from '../components/Heatprofile/ProjectHeatProfilePDFViewer';
import HeatProfileImageViewer from '../components/Heatprofile/HeatProfileImageViewer';
import MaterialsMainPage from '../components/Materials/MaterialsMainPage';
import DPRPage from '../pages/dpr/DPRPage';
import DashboardPage from '../pages/dashboard/DashboardPage';
import EngineeringPage from '../pages/engineering/EngineeringPage';

/** Legacy `/dashboard` URL → canonical projects hub at `/projects`. */
const DashboardToProjectsRedirect = () => <Redirect to="/projects" />;
const CoilConfiguratorToEngineeringRedirect = () => <Redirect to="/engineering" />;

export default [
    {
        path: '/',
        exact: true,
        layout: HomeLayout,
        component: Home,
    },

    {
        path: '/dashboard',
        layout: ModernLayout,
        component: DashboardPage,
    },

    {
        path: '/log-report',
        layout: HomeLayout,
        component: AnalysisPage,
    },

    {
        path: '/asset-management',
        layout: HomeLayout,
        component: Admin,
    },

    {
        path: '/admin',
        layout: HomeLayout,
        component: AdminPage,
    },

    {
        path: '/web-page',
        layout: HomeLayout,
        component: WebpageMsg,
    },

    {
        path: '/technical',
        layout: HomeLayout,
        component: Technical,
    },
    {
        path: '/engineering',
        exact: true,
        layout: ModernLayout,
        component: EngineeringPage,
    },
    {
        path: '/calibration-control',
        layout: HomeLayout,
        component: DocControl,
    },

    {
        path: '/heat-profile',
        layout: ModernLayout,
        component: HeatProfilePage,
    },
    {
        path: '/calibration',
        layout: ModernLayout,
        component: CalibrationPage,
    },
    {
        path: '/admin/calibration-control-users',
        exact: true,
        layout: ModernLayout,
        component: AdminModernPage,
    },
    {
        path: '/admin/employees',
        exact: true,
        layout: ModernLayout,
        component: AdminModernPage,
    },
    {
        path: '/admin/spares',
        exact: true,
        layout: ModernLayout,
        component: AdminModernPage,
    },
    {
        path: '/admin/documentation',
        exact: true,
        layout: ModernLayout,
        component: AdminModernPage,
    },
    {
        path: '/admin/communications',
        exact: true,
        layout: ModernLayout,
        component: AdminModernPage,
    },
    {
        path: '/admin/reporting-email',
        exact: true,
        layout: ModernLayout,
        component: AdminModernPage,
    },
    {
        path: '/admin/user-management',
        exact: true,
        layout: ModernLayout,
        component: AdminModernPage,
    },
    {
        path: '/admin/shipping-management',
        exact: true,
        layout: ModernLayout,
        component: AdminModernPage,
    },
    {
        path: '/admin/asset-management',
        exact: true,
        layout: ModernLayout,
        component: AdminModernPage,
    },
    {
        path: '/admin/consumable',
        exact: true,
        layout: ModernLayout,
        component: AdminModernPage,
    },
    {
        path: '/admin/material',
        exact: true,
        layout: ModernLayout,
        component: AdminModernPage,
    },
    {
        path: '/materials',
        layout: HomeLayout,
        component: MaterialsMainPage,
    },

    {
        path: '/TechnicalPage',
        exact: true,
        layout: ModernLayout,
        component: TestRepositoryPage,
    },
    {
        path: '/TechnicalPage/pdf/:id',
        layout: HomeLayout,
        component: TechnicalPDFViewer,
    },
    {
        path: '/heat-profile/pdf/:id',
        layout: HomeLayout,
        component: HeatProfilePDFViewer,
    },
    {
        path: '/project-heat-profile/pdf/:id',
        layout: HomeLayout,
        component: ProjectHeatProfilePDFViewer,
    },
    {
        path: '/heat-profile/image/:id',
        layout: HomeLayout,
        component: HeatProfileImageViewer,
    },
    {
        path: '/TechnicalTestPage',
        layout: HomeLayout,
        component: TechnicalReportPage,
    },
    {
        path: '/DCALGenerator',
        layout: ModernLayout,
        component: DCALGeneratorPage,
    },
    {
        path: '/AskEvans',
        layout: ModernLayout,
        component: AssistancePage,
    },
    // Example: Opt-in to ModernLayout by setting layout: ModernLayout
    {
        path: '/projects',
        exact: true,
        layout: ModernLayout,
        component: DashboardPage,
    },
    // DPR route with ModernLayout - opens in new tab
    {
        path: '/dpr',
        exact: true,
        layout: ModernLayout,
        component: DPRPage,
    },
    {
        path: '/coil-configurator',
        exact: true,
        layout: ModernLayout,
        component: CoilConfiguratorToEngineeringRedirect,
    },
    // {
    //   path: '/DCAlUpdatePage',
    //   layout: HomeLayout,
    //   component: DcalUpdateForm,
    // }
    // {
    //   path: '/maintenance-history',
    //   layout: HomeLayout,
    //   component: Home,
    // },
];
